import "react-datetime/css/react-datetime.css";
import { Collapse, TableCell, TableRow, Icon } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";

import TableFormat from "../../../partials/TableFormat";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import CampaignCard from "./campaignCard";
import { styles } from "./styles";
import GradeIcon from "@material-ui/icons/Grade";
import Tooltip from "@material-ui/core/Tooltip";
const headCells = [
  {
    key: "title",
    numeric: false,
    disablePadding: false,
    label: "campaign_list_campaign_title",
  },
  {
    key: "campaignCode",
    numeric: false,
    disablePadding: false,
    label: "campaign_list_campaign_code",
  },
  {
    key: "type",
    numeric: false,
    disablePadding: false,
    label: "campaign_list_campaign_type",
  },
  {
    key: "startDate",
    numeric: false,
    disablePadding: false,
    label: "campaign_list_campaign_start_date",
  },
  {
    key: "endDate",
    numeric: false,
    disablePadding: false,
    label: "campaign_list_campaign_end_date",
  },
  { key: "active", numeric: false, disablePadding: false, label: "" },
];

class ListCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "code",
      colorSnackbar: "white",
      selected: [],
      index: 0,
      data: [],
      listCampaign: [],
      collapse: [],
      flagOpen: false,
      memberCardSend: "",
    };
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
  }
  componentWillMount() {
    this.props.onRef(null);
  }
  componentDidMount() {
    this.props.onRef(this);
  }
  getListCampaign = async (payload = {}) => {
    this.loading.startLoading();
    let check = await this.props.getList({
      limit: this.mTable.state.rowsPerPage,
      page: this.mTable.state.page,
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message, "error");
  };
  async handleSubmitDelete(selected = []) {
    var { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.delete({ ids: selected });
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("membercard_list_delete_successfully"));
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("membercard_list_delete_unsuccessfully") + " " + check.message,
          "error"
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  }
  handleOpenCollapes = (id) => {
    const listCampaign = this.props.listCampaign;
    const collapse = this.state.collapse;
    for (var i = 0; i <= listCampaign.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };
  finishUpdate = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    check.code === 1
      ? this.mSnackbar.handleClick(t("membercard_list_update_successfully"))
      : this.mSnackbar.handleClick(
          t("membercard_list_update_unsuccessfully") + " " + check.message,
          "error"
        );
    this.props.getList();
  };
  renderCollapse = (row, index) => {
    const { classes, listCampaign } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow key={index} className={classes.tableCellInCollapes}>
        <TableCell
          colSpan={8}
          padding={"none"}
          className={classes.tableCellEdit}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <CampaignCard
              data={listCampaign[index]}
              finishUpdate={this.finishUpdate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  renderActive = (active) => {
    if (active == 1) {
      return (
        <Tooltip title="Campaign active">
          <Icon color="secondary">
            <GradeIcon />
          </Icon>
        </Tooltip>
      );
    } else return null;
  };
  render() {
    const { classes, t, total, count } = this.props;
    const listCampaign = this.props.listCampaign;
    const { collapse = [] } = this.state;
    return (
      <React.Fragment className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t("do_you_want_delete_campaign")}
          onDelete={this.handleSubmitDelete}
          title={t("campaign_list_campaign")}
          showFilter={false}
          showActionToolbar={false}
          placeholder={t("campaign_search_title_code")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          collapse={collapse}
          isCollapse={true}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getListCampaign}
          rows={listCampaign.map((row, index) => {
            return {
              id: row._id,
              title: row.title,
              campaignCode: row.campaignCode,
              type: row.type,
              startDate: moment(row.startDate).format("DD/MM/YYYY"),
              endDate: moment(row.endDate).format("DD/MM/YYYY"),
              active: this.renderActive(row.enable),
            };
          })}
        />
      </React.Fragment>
    );
  }
}

ListCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.campaigns.total,
  count: state.campaigns.count,
  listCampaign: state.campaigns.listCampaign,
});

const mapDispatch = (dispatch) => ({
  delete: dispatch.campaigns.deleteById,
  getList: dispatch.campaigns.getList,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListCampaign)
  )
);
